import * as AT from '../constants/actionTypes'

/**
 * Setting reducer
 * @param {*} state 
 * @param {*} action 
 */
function setting(state = { settings: [] }, action) {
	switch (action.type) {
		case AT.SETTING_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				settings: [],
				error: undefined
			})
		case AT.SETTING_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.SETTING_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				settings: action.payload.settings,
				error: undefined
			})
		case AT.SETTING_SAVING_STARTED:
			return Object.assign({}, state, {
				isSaving: true,
				error: undefined
			})
		case AT.SETTING_SAVING_FAILED:
			return Object.assign({}, state, {
				isSaving: false,
				error: action.payload.error
			})
		case AT.SETTING_SAVING_FINISHED:
			return Object.assign({}, state, {
				isSaving: false,
				settings: [ ...state.settings, updateSetting(state.settings, action.payload.setting.key, action.payload.setting.value) ],
				error: undefined
			})
		case AT.SETTING_UI_CLEAR:
			return Object.assign({}, state, {
				error: undefined
			})
		default:
			return state;
	}
}

function updateSetting(settings, key, value) {
	var item = settings.filter( s => s.key === key )[0];
	item.value = value;
	return item;
}

export default setting;